import { Component, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as moment from 'moment';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { TripContextService } from 'src/app/Services/trip-context.service';


@Component({
  selector: 'app-bottommenu',
  templateUrl: './bottommenu.component.html',
  styleUrls: ['./bottommenu.component.css'],
})
export class BottommenuComponent implements OnInit {
  currentdate: string | undefined;
  CurrentTime: string | undefined;
  pagemask: boolean | undefined; 

  cruiseBeg: Date | undefined; 
  cruiseEnd: Date | undefined; 
  pckgBeg: Date | undefined; 

  userdata?: UserData;
 

  constructor(
    private tripContextService: TripContextService
  ) {}

  ngOnInit(): void {
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');

    this.pagemask = this.tripContextService.resolve(this.userdata).pagemask;
  }




}